window.WIQCache = {};
class BYSDrawerOpener extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.button.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    const drawer = document.querySelector("build-your-set-drawer");
    if (drawer) drawer.show(this.button);
  }
}
customElements.define("bys-drawer-opener", BYSDrawerOpener);

class BuildYourSetDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawerContent = this.querySelector("[data-wiq-set-html]");
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    this.addEventListener("click", (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    document.addEventListener(
      "wiq-bys:variant-change",
      this.onVariantChange.bind(this)
    );
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.openedBy.classList.add("loading");
    this.loadContent(this.openedBy.dataset.productHandle);
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
  }

  initEvents() {
    this.initSwiper();
    this.addToCartBtn = this.querySelector("[data-wiq-add-to-cart-button]");
    this.addToCartBtn.addEventListener("click", this.addToCart.bind(this));
  }

  initSwiper() {
    this.slider = new Swiper("[data-wiq-slider]", {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 1 },
      },
      on: {
        slideChangeTransitionEnd: this.onVariantChange.bind(this),
        init: this.onVariantChange.bind(this),
      },
    });
  }

  loadContent(handle) {
    this.fetchProduct(handle)
      .then((html) => {
        this.drawerContent.innerHTML = html;
      })
      .finally(() => {
        if (this.openedBy) this.openedBy.classList.remove("loading");
        this.initEvents();
        this.setAttribute("open", "");
      });
  }

  fetchProduct(handle, variantId = null) {
    if (window.WIQCache[handle]) {
      return Promise.resolve(window.WIQCache[handle]);
    }
    var path = `/products/${handle}`;
    if (variantId) path += `/variants/${variantId}`;
    path += `?section_id=build-your-set-drawer`;

    return fetch(path)
      .then((res) => res.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, "text/html");
        const product = dom.querySelector("[data-wiq-set-html]");
        window.WIQCache[handle] = product.innerHTML;
        return product.innerHTML;
      });
  }

onVariantChange() {
    var price = 0;
    this.disabled = false;
    this.querySelectorAll(
      ".bys-parent bys-product-card, .swiper-slide-active bys-product-card"
    ).forEach((card) => {
      console.log(card.currentVariant.name);
      price += card.currentVariant.price;
      if (!card.currentVariant.available) {
        this.disabled = true;
      }
    });

    // ✅ Null check — content may not be rendered yet
    const totalPriceEl = this.querySelector("[data-wiq-total-price]");
    if (totalPriceEl) {
      totalPriceEl.textContent = Shopify.formatMoney(price);
    }

    this.addToCartBtn =
      this.addToCartBtn || this.querySelector("[data-wiq-add-to-cart-button]");

    // ✅ Null check — button may not exist yet either
    if (!this.addToCartBtn) return;

    if (this.disabled) {
      this.addToCartBtn.setAttribute("disabled", "");
    } else {
      this.addToCartBtn.removeAttribute("disabled");
    }
  }

  addToCart(event) {
    event.preventDefault();
    this.addToCartBtn.setAttribute("disabled", "");
    this.addToCartBtn.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    var items = [];
    this.querySelectorAll(
      ".bys-parent bys-product-card, .swiper-slide-active bys-product-card"
    ).forEach((card) => {
      if (card.currentVariant.available) {
        items.push({
          id: card.currentVariant.id,
          quantity: 1,
        });
      }
    });

    var body = {
      items: items,
    };

    if (this.cart) {
      body.sections = this.cart
        .getSectionsToRender()
        .map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          throw new Error(parsedState.errors);
        }
        if (this.cart) {
          this.cart.renderContents(parsedState);
          this.removeAttribute("open");
        } else {
          window.location.href = "/cart";
        }
      })
      .finally(() => {
        this.addToCartBtn.classList.remove("loading");
        this.addToCartBtn.removeAttribute("disabled");
        this.addToCartBtn
          .querySelector(".loading-overlay__spinner")
          .classList.add("hidden");
      });
  }
}
customElements.define("build-your-set-drawer", BuildYourSetDrawer);

class BYSProductCard extends HTMLElement {
  constructor() {
    super();
    this.onVariantInputClickListener = this.onVariantInputClick.bind(this);
    this.price = this.querySelector("[data-wiq-price]");
    this.swatchListener = this.onSwatchClick.bind(this);
    this.swatchHoverListener = this.onSwatchHover.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll("[data-variant-input]").forEach((button) => {
      button.addEventListener("click", this.onVariantInputClickListener);
    });
    this.onVariantChange();

    this.querySelectorAll(".swatch-btn").forEach((btn) => {
      btn.addEventListener("click", this.swatchListener);
      btn.addEventListener("mouseenter", this.swatchHoverListener);
    });

     // ✅ ADD THIS
    const atcBtn = this.querySelector(".bys-cart-atc-btn");
    if (atcBtn) {
      atcBtn.addEventListener("click", this.onAddToCart.bind(this));
    }
  }

  disconnectedCallback() {
    this.querySelectorAll("[data-variant-input]").forEach((button) => {
      button.removeEventListener("click", this.onVariantInputClickListener);
    });
    this.querySelectorAll(".swatch-btn").forEach((btn) => {
      btn.removeEventListener("click", this.swatchListener);
      btn.removeEventListener("mouseenter", this.swatchHoverListener);
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(
        "[data-variant-option] [data-variant-input].active"
      ),
      (button) => button.dataset.value
    );
  }
  updateMasterId() {
    if (this.options.length === 0) {
      this.variant = this.getVariantData()[0];
      return;
    }
    this.variant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  onVariantInputClick(event) {
    const btn = event.currentTarget;
    const fieldset = btn.closest("[data-variant-option]");
    fieldset.querySelectorAll("[data-variant-input]").forEach((button) => {
      button.classList.remove("active");
    });
    btn.classList.add("active");
    this.onVariantChange();
  }

onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (this.variant) {
      this.currentVariant = this.variant;
      if (this.price)
        this.price.textContent = Shopify.formatMoney(this.variant.price);

      // ✅ ADD THIS — keep button's variant id in sync
      const atcBtn = this.querySelector(".bys-cart-atc-btn");
      if (atcBtn) {
        atcBtn.dataset.variantId = this.variant.id;
      }

      this._dispatchEvent();
    }
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-wiq-variants-json]").textContent);
    return this.variantData;
  }

  fetchProduct(handle) {
    const card = `card-${handle}`;
    if (window.WIQCache[card]) {
      return Promise.resolve(window.WIQCache[card]);
    }

    return fetch(`/products/${handle}?section_id=build-your-set-product-card`)
      .then((res) => res.text())
      .then((html) => {
        const dom = new DOMParser().parseFromString(html, "text/html");
        const product = dom.querySelector(".shopify-section");
        window.WIQCache[card] = product.innerHTML;
        return product.innerHTML;
      });
  }

  onSwatchClick(event) {
    const btn = event.currentTarget;
    const productHandle = btn.dataset.productHandle;
    this.fetchProduct(productHandle).then((html) => {
      this.parentElement.innerHTML = html;
    });
  }

  onSwatchHover(event) {
    const btn = event.currentTarget;
    const productHandle = btn.dataset.productHandle;
    this.fetchProduct(productHandle);
  }
  onAddToCart() {
    const atcBtn = this.querySelector(".bys-cart-atc-btn");
    const variantId = atcBtn?.dataset.variantId || this.currentVariant?.id;
    if (!variantId) return;

    atcBtn.classList.add("loading");
    atcBtn.disabled = true;

    const cartDrawer = document.querySelector("cart-drawer");

    const body = {
      items: [{ id: parseInt(variantId), quantity: 1 }],
    };

    // If cart drawer exists, request section re-render
    if (cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify?.routes?.cart_add_url || "/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.errors) {
          console.error("ATC error:", state.errors);
          return;
        }
        // Re-render cart drawer — this naturally removes Complete Your Set
        // if this product is now in cart (Liquid loop won't match anymore)
        if (cartDrawer && state.sections) {
          cartDrawer.renderContents(state);
        } else {
          // fallback: reload cart
          window.location.href = "/cart";
        }
      })
      .catch((err) => console.error("ATC fetch error:", err))
      .finally(() => {
        atcBtn.classList.remove("loading");
        atcBtn.disabled = false;
      });
  }
  _dispatchEvent() {
    document.dispatchEvent(new CustomEvent("wiq-bys:variant-change"));
  }
}

customElements.define("bys-product-card", BYSProductCard);
